import { inject, Injectable } from '@angular/core'
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http'
import { Router } from '@angular/router'
import { Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'

import { SessionService } from '../_services'

@Injectable({
  providedIn: 'root'
})
export class ErrorInterceptor implements HttpInterceptor {

  sessionService: SessionService = inject(SessionService)
  router: Router = inject(Router)

  constructor() {}

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError((err) => {
      if (err.status === 401) {
        // Aktuelle URL merken und nach Logout als returnUrl mitgeben
        const currentUrl = this.router.url
        this.sessionService.logoutWithReturnUrl(currentUrl)
      }

      const error = err.error.message || err.statusText
      return throwError(error)
    }))
  }
}
